/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientOutConfirmationAliases {
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FIELD_ATENDIMENTO = 'field-atendimento',
  FIELD_DESTINO = 'field-destino',
  FIELD_PRONTUARIO = 'field-prontuario',
  FORM_FIELDS = 'form-fields',
  FRAGMENT_REFERENCE_0 = 'fragment-reference-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_MAIN = 'layout-main',
  PANEL_LOADER = 'panel-loader',
  TEXT_ATENDIMENTO = 'text-atendimento',
  TEXT_DESTINO = 'text-destino',
  TEXT_SOLICITACAO = 'text-solicitacao',
}
export { PatientOutConfirmationAliases };
